module.exports = __webpack_public_path__ + "headerFaqSlide.43e69eb7f94df76d0f5a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/headerFaqSlide.jpg
// module id = ../../../../../src/assets/coverPicks/headerFaqSlide.jpg
// module chunks = 0